import React from "react";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";

const DeleteModal = ({ deleteTasksHandler, showDeleteModal, closeDeleteModal, submitDisabled }) => (
  <Modal
    show={showDeleteModal}
    onHide={closeDeleteModal}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Are you sure?" closeButton />
    <Modal.Body>
      Unlike archiving a contact, deleting a task is permanent. Your client won’t be able to see that the
      task(s) was deleted, but they also won’t be able to see if you completed the task(s), either.
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
      <Button size="medium" className="modal-cancel tw-float-left" onClick={closeDeleteModal}>
        Cancel
      </Button>
      <Button size="medium" schema="warning" onClick={deleteTasksHandler} isLoading={submitDisabled}>
        Yes, Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DeleteModal;
